export default {
  state: {
    data: false,
  },
  getters: {},
  actions: {
    resetTechnician(context) {
      context.commit("updateTechnician", false);
    },
  },
  mutations: {
    updateTechnician(state, data) {
      return (state.data = data);
    },
  },
};
